export function num_word(value: number, words: string[]) {
  const abs_value = Math.abs(value) % 100;
  const num = abs_value % 10;
  if (abs_value > 10 && abs_value < 20) return value + ' ' + words[2];
  if (num > 1 && num < 5) return value + ' ' + words[1];
  if (num == 1) return value + ' ' + words[0];
  return value + ' ' + words[2];
}

const dateInterval = (date: string): string => {
  // days, hours, minutes
  let delta = Math.floor((Number(new Date()) - Number(new Date(date))) / 1000);
  const days = Math.floor(delta / 86400);
  delta -= days * 86400;
  const hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;
  const minutes = Math.floor(delta / 60) % 60;

  /// Delta for yaers and month
  const month = Math.floor(
    (new Date().getDate() - new Date(date).getDate()) / 30 +
      new Date().getMonth() -
      new Date(date).getMonth() +
      12 * (new Date().getFullYear() - new Date(date).getFullYear()),
  );
  const years = Math.floor(month / 12);
  //

  const yearsWords = ['год назад', 'года назад', 'лет назад'];
  const monthWords = ['месяц назад', 'месяца назад', 'месяцев назад'];
  const daysWords = ['день назад', 'дня назад', 'дней назад'];
  const hoursWords = ['час назад', 'часа назад', 'часов назад'];
  const minutesWords = ['минуту назад', 'минуты назад', 'минут назад'];

  if (years > 0) {
    return num_word(years, yearsWords);
  } else if (month > 0) {
    return num_word(month, monthWords);
  } else if (days > 0) {
    return num_word(days, daysWords);
  } else if (hours > 0 && hours < 24) {
    return num_word(hours, hoursWords);
  } else {
    return num_word(minutes, minutesWords);
  }
};

export default dateInterval;
